export type AddressValidatorsType = Readonly<{
  additionalInformation1: () => boolean;
  additionalInformation2: () => boolean;
  addOn: () => boolean;
  city: () => boolean;
  country: () => boolean;
  countryCode: () => boolean;
  number: () => boolean;
  stateOrDistrict: () => boolean;
  street: () => boolean;
  streetNumber: () => boolean;
  town: () => boolean;
  zipCode: () => boolean;
}>;
const ADDRESS_FIELDS_ORDER = [
  'streetNumber',
  'streetName',
  'zipCode',
  'city',
  'additionalInformation1',
  'additionalInformation2',
  'addOn',
  'town',
  'stateOrDistrict',
  'countryCode',
];
export const fieldsSort = (field1: ValidationSchema, field2: ValidationSchema) =>
  ADDRESS_FIELDS_ORDER.indexOf(field1.name) - ADDRESS_FIELDS_ORDER.indexOf(field2.name);
